type ActionBarVariant = 'top' | 'bottom';
type ActionBarSize = 'none' | 'small' | 'medium' | 'large';

interface ActionBarProps {
  children: React.ReactNode;
  variant?: ActionBarVariant;
  size?: ActionBarSize;
  className?: string;
  borderStyle?: 'solid' | 'dashed' | 'dotted' | 'none';
}

const ActionBar: React.FC<ActionBarProps> = ({
  children,
  variant = 'bottom',
  size = 'medium',
  className = '',
  borderStyle = 'solid'
}) => {
  // Size variants for padding
  const sizeClasses = {
    none: '~py-0',
    small: '~py-1.5/2',
    medium: '~py-2/3',
    large: '~py-3/4'
  };

  // Border styles
  const borderStyles = {
    solid: 'border-solid',
    dashed: 'border-dashed',
    dotted: 'border-dotted',
    none: 'border-none'
  };

  // Variant determines border position
  const borderClass =
    variant === 'top'
      ? `border-b border-secondary-400/60 dark:border-gray-600 ${borderStyles[borderStyle]}`
      : `border-t border-secondary-400/60 dark:border-gray-600 ${borderStyles[borderStyle]}`;

  const paddingClass = sizeClasses[size];

  return (
    <div
      className={`w-full flex items-center justify-between ${paddingClass} ${borderClass} ${className}`}
      role='toolbar'
      aria-label='Action bar'
    >
      {children}
    </div>
  );
};

export default ActionBar;
